<script setup lang="ts">
// Picks the shell for the viewport and keeps body[data-view] in step with the route, because the production
// stylesheets key page chrome on it. Desktop: sidebar + workspace bar + #view. Phone: #view + tab bar.
// A route that is full bleed (map, exam guide) gets #view.view-full-bleed and drops the page padding.
import { computed, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DesktopSidebar from './DesktopSidebar.vue'
import WorkspaceBar from './WorkspaceBar.vue'
import PhoneTabbar from './PhoneTabbar.vue'
import DesktopFooter from './DesktopFooter.vue'
import { isDesktop, setViewAttribute } from './useShell'
import { shellInfo } from './nav'

const route = useRoute()
const router = useRouter()
const info = computed(() => shellInfo(route.path))
watchEffect(() => setViewAttribute(info.value.view))
</script>

<template>
  <template v-if="isDesktop">
    <DesktopSidebar />
    <!-- Shown instead of the sidebar while a screen runs full-screen (body.quiz-answering); assets/js/app.js #immersiveNav. -->
    <nav id="immersiveNav" class="immersive-nav" aria-label="子界面导航">
      <button class="immersive-brand" type="button" title="回到首页" @click="router.push('/')">
        <img src="/assets/desktop-ui/logo.png" alt="导游学霸品牌标志" />
        <span><b>导游学霸</b><small><span id="immersiveModuleName">{{ info.title }}</span> · DAOYOUXUEBA.COM</small></span>
      </button>
      <div>
        <button type="button" @click="router.back()">← 返回上一级</button>
        <button type="button" @click="router.push('/')">回到首页</button>
      </div>
    </nav>
    <WorkspaceBar />
    <main id="view" :class="{ 'view-full-bleed': info.fullBleed, 'map-full': info.view === 'map-home' }" tabindex="-1" aria-label="学习内容">
      <slot />
    </main>
    <DesktopFooter :show-faq="info.view === 'home' || info.view === 'interview-practice' || info.view === 'shop' || info.view === 'me' || info.view === 'video' || info.view === 'guide'" />
  </template>
  <template v-else>
    <main id="view" :class="{ 'map-full': info.fullBleed, 'view-full-bleed': info.fullBleed }" tabindex="-1" aria-label="学习内容">
      <slot />
    </main>
    <PhoneTabbar />
  </template>
</template>
